export default __webpack_public_path__ + "media/zurb/img/lab/playground/responsive-email-templates/hero-19c903227b5acba029fe3e92231814cd.jpg";